import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSession } from '../context/SessionContext';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { sessionLanguage, setSessionLanguage } = useSession();

  // Sincronizar sessionLanguage cuando i18n cambia
  useEffect(() => {
    console.log('🔄 [LanguageSelector] i18n.language changed to:', i18n.language);
    console.log('📍 [LanguageSelector] Current sessionLanguage:', sessionLanguage);
    
    // Si i18n.language es diferente de sessionLanguage, actualizar
    if (i18n.language && i18n.language !== sessionLanguage) {
      console.log('⚠️  [LanguageSelector] Mismatch detected! Updating sessionLanguage to:', i18n.language);
      setSessionLanguage(i18n.language);
    }
  }, [i18n.language, sessionLanguage, setSessionLanguage]);

  const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' }
  ];

  const changeLanguage = (lng) => {
    console.log('🌐 [LanguageSelector] User selected language:', lng);
    
    // 1. Actualizar localStorage INMEDIATAMENTE con ambas claves
    localStorage.setItem('sessionLanguage', lng);
    localStorage.setItem('i18nextLng', lng);
    localStorage.setItem('DEBUG_selectedLanguage', lng);
    console.log('💾 [LanguageSelector] localStorage updated:', {
      sessionLanguage: lng,
      i18nextLng: lng,
    });
    
    // 2. Actualizar sessionLanguage en el context
    setSessionLanguage(lng);
    console.log('✅ [LanguageSelector] setSessionLanguage called with:', lng);
    
    // 3. Actualizar i18n (esto causa re-render del componente)
    i18n.changeLanguage(lng);
    console.log('🔤 [LanguageSelector] i18n.changeLanguage called with:', lng);
  };

  const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="language-selector">
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="language-select"
      >
        {languages.map(lang => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;